// Rangos de fechas
export const DATE_RANGES = {
  INITIAL_DAYS_BACK: 8,
  FINAL_DAYS_FORWARD: 3,
};

// Estados de envío de estudios
export const ENVIO_ESTUDIOS = {
  E: 'Correo electrónico',
  P: 'Correo postal',
  W: 'WhatsApp',
  C: 'Personalmente',
};

// Estados de estudio
export const ESTADO_ESTUDIO = {
  S: 'Realizado',
  N: 'No Completado',
  C: 'Cancelado',
};

// Badges de estado
export const ESTADO_BADGES = {
  'Otorgado': 'primary',
  'Solicitado': 'warning',
  'En proceso': 'info',
  'Realizado': 'success',
  'Listo para Enviar': 'primary',
  'Revisar': 'success',
  'Corregir': 'warning',
  'Cancelado': 'danger',
  'Asistio': 'success',
  'No Asistio': 'danger',
};

// Colores de prioridad
export const PRIORIDAD_COLORS = {
  VENCIDO: '#dc3545',
  VENCE_MANANA: '#ff9800',
};

// Validación de archivos
export const FILE_VALIDATION = {
  ALLOWED_EXTENSIONS: ['.docx', '.doc', '.pdf'],
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
};

// Valores por defecto
export const DEFAULT_VALUES = {
  ID_ALL: -1,
  EMPTY_STRING: '',
  NO_DATA: 'N/A',
  NO_DATA_DASH: '-',
};
